<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Expense Report
    </div>
    <div class="card-body">
        <div class="row mb-1">
            <div class="col-md-auto">
                <label for="optype" class="form-label text-label-dark">Report Type :</label>
            </div>
            <div class="col-md-3">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='ExpenseReport' name="optype"
                            [(ngModel)]="Filter.DataType" [ngModelOptions]="{standalone: true}" required>
                        Detail
                    </label>
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='ExpenseReportSummary' name="optype"
                            [(ngModel)]="Filter.DataType" [ngModelOptions]="{standalone: true}" required>
                        Summary
                    </label>
                </div>
            </div>


             <div class="col-auto">
                <label for="emptype" class="form-label text-label-dark">Emp Type :</label>
            </div>
            <div class="col-md-4">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='All' name="emptype"
                            [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}" required>
                        All
                    </label>
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Front' name="emptype"
                            [(ngModel)]="Filter.DataType" [ngModelOptions]="{standalone: true}" required>
                        Front
                    </label>
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Back' name="emptype"
                            [(ngModel)]="Filter.DataType" [ngModelOptions]="{standalone: true}" required>
                        Back
                    </label>
                </div>
            </div>

        </div>
        <div class="row mt-2">
            <div class="col-md-9">
                <div class="card p-3 shadow-sm">

                    <h6 class="mb-2 fw-bold" style="font-size: 14px">Filter Date Based On</h6>

                    <!-- Radio buttons in single line -->
                    <div class="d-flex flex-wrap gap-3 mb-2">

                        <div class="form-check">
                            <input class="form-check-input mt-2" type="radio" name="reportType"
                                [(ngModel)]="Filter.ReportType" value="R">
                            <label class="form-check-label">
                                Request Date
                            </label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input mt-2" type="radio" name="reportType"
                                [(ngModel)]="Filter.ReportType" value="E">
                            <label class="form-check-label">
                                Expense Date
                            </label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input mt-2" type="radio" name="reportType"
                                [(ngModel)]="Filter.ReportType" value="A">
                            <label class="form-check-label">
                                Approval Date
                            </label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input mt-2" type="radio" name="reportType"
                                [(ngModel)]="Filter.ReportType" value="RI">
                            <label class="form-check-label">
                                Reimbursement Date
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-1 mt-1">
            <div class="col-md-3 px-1 me-2">
                <label class="Label">From Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="fromdate " placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="Filter.FromDateObj" #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter from date !
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">To Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="todate " placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="Filter.ToDateObj" #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter from date !
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-3 px-1">
                
            </div> -->
        </div>
        <div class="row mb-1 mt-3">
            <div class="col-md-auto">
                <label for="expensetype" class="form-label text-label-dark">Travel Type :</label>
            </div>
            <div class="col-md-6">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-2" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='All' name="expensetype"
                            [(ngModel)]="Filter.TravelType" [ngModelOptions]="{standalone: true}" required>
                        All
                    </label>
                    <label class="form-check-label link-dark px-2" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Local' name="expensetype"
                            [(ngModel)]="Filter.TravelType" [ngModelOptions]="{standalone: true}" required>
                        Local
                    </label>
                    <label class="form-check-label link-dark px-2" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Outstation' name="expensetype"
                            [(ngModel)]="Filter.TravelType" [ngModelOptions]="{standalone: true}" required>
                        Outstation
                    </label>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label class="Label">Reimbursement Type<span class="text-danger">*</span></label>
                <ng-select name="allocationtype" [(ngModel)]="Filter.ReimbursementType"
                    placeholder="Select Approval Type">
                    <ng-option [value]="'All'">
                        All
                    </ng-option>
                    <ng-option [value]="'Reimbursed'">
                        Reimbursed
                    </ng-option>
                    <ng-option [value]="'Pending'">
                        Pending
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-4">
                <label class="Label">Employee Code</label>
                <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.EmpCode"
                    placeholder="Employee Code" />
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="exportToExcel()" type="button" class="btn btn-primary me-2" [disabled]="isDisabled"><i class="bi bi-file-earmark-spreadsheet"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>